import { PropertyObjectTypesIds, PropertyObjectTypes } from 'ui-forms-components/constants/PropertyObjectTypes';
export default PropertyObjectTypesIds[PropertyObjectTypes.COMPANY];